"use client";

import { motion } from "motion/react";
import { CustomButton } from "@/components/ui/custom-button";
import { AIBeam } from "./ai_beam";
import { useTranslations } from "next-intl";
import Link from "next/link";

export function AIExplanation() {
	const t = useTranslations("navbar");

	return (
		<section className="flex justify-center" aria-label="Ethical AI introduction">
			<div className="flex w-full flex-col">
				{/* AI Header */}
				<motion.div
					initial={{ opacity: 0, y: 60 }}
					animate={{ opacity: 1, y: 0 }}
					className="-mt-12 flex flex-col items-center justify-center space-x-2"
				>
					<h1 className="text-lg font-bold">
						Ethical, Secure AI
					</h1>
					<motion.p
						initial={{ opacity: 0, y: 60 }}
						animate={{ opacity: 1, y: 0 }}
						className="mt-3 px-4 text-center text-base text-gray-700 md:text-lg"
					>
						StudyStash works with a range of AI models - including Claude, OpenAI, Meta, and Gemini - and partners with you to choose the one that best fits your institution.
					</motion.p>
					<motion.div
						initial={{ opacity: 0, y: 60 }}
						animate={{ opacity: 1, y: 0 }}
						className="mt-4 flex justify-center"
					>
						<Link href="https://trust.studystash.com">
							<CustomButton 
								variant="outline" 
								size="md"
								aria-label="Visit Trust Centre"
							>
								{t("trust-centre")}
							</CustomButton>
						</Link>
					</motion.div>
				</motion.div>
				
				{/* Hero Section */}
				<div className="flex flex-col items-center justify-center pt-2">
					<motion.div
						initial={{ opacity: 0, y: 60 }}
						animate={{ opacity: 1, y: 0 }}
						className="mt-4 w-full px-3 md:px-8"
					>
						<AIBeam />
					</motion.div>
				</div>
			</div>
		</section>
	);
}
